import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for initialization if not done
  if (!authService.isInitialized()) {
    await authService.init();
  }

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to login page
  router.navigate(['/login']);
  return false;
};

export const publicGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for initialization if not done
  if (!authService.isInitialized()) {
    await authService.init();
  }

  if (authService.isAuthenticated()) {
    // Already authenticated, redirect to dashboard
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
